<script>
import GoogleMap from '@/components/googleMap'
export default {
  data () {
    return {
      mapId: 'mapShow',
      centerPoint: {
        lat: 34.873838,
        lng: 132.7209652
      },
      markPosition: {
        lat: 34.873838,
        lng: 132.7209652
      },
      mapTitle: ''
    }
  },
  props: {
  },
  methods: {
    initiGoogleMap () {
      let imgSize = {width: 20, height: 54}
      this.$refs.gMap.centerPointObj = this.centerPoint
      this.$refs.gMap.initializeGoogleMap().then(
        () => {
          this.$refs.gMap.map.setZoom(12)
          this.$refs.gMap.addSingleMaker(this.markPosition, imgSize, 'station-label-class')
        }
      )
    }
  },
  components: { GoogleMap }
}
</script>

<template>
    <div class="col-md-12 column">
        <div class="modal fade" id="modal-container-staySave" role="dialog" data-backdrop="static" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img height="30px" src="@/assets/X.png" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;"/></button>
                        <div class="overflow-fix">
                            <strong class="modal-title" id="myModalLabel">
                                {{this.mapTitle}}
                            </strong>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="row clearfix">
                            <div class="col-md-1 column"></div>
                            <div class="col-md-8 column" style="width:100%">
                                <div style="width:100%">
                                    <GoogleMap ref="gMap"
                                        :map-id="mapId"
                                        :center-point="centerPoint">
                                    </GoogleMap>
                                </div>
                            </div>
                        <div class="col-md-1 column"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .modal-dialog{
        width: 600px;;
    }
    .modal-header{
        margin-bottom: -30px;
        border-bottom: 0px;
    }
    .modal-title{
        font-size: 28px;
    }
    .modal-body{
        padding-left: 20px;
        padding-right: 20px;
    }
    .close{
        opacity: 1;
    }
</style>



// WEBPACK FOOTER //
// src/components/showMapWindowMask.vue